import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import IndividualProduct from "../components/individualProduct";
import ProductsBanner from "../components/ProductsBanner";
import WhatsAppFloatingButton from "../components/WhatsAppFloatingButton";
import { Helmet } from "react-helmet";


const BloodGlucos2 = () => {
  const title = "Dr. Chek D - Accurate Blood Glucose Monitoring";
  const description =
    "The Dr. Chek D Glucose Oxidase-based Blood Glucose Meter provides accurate and reliable blood sugar testing. Ideal for home glucose monitoring and diabetes management.";
  const productData = {
    name: "Dr. Chek D+",
    image: "/images/Dr Chek D+ (GDH)  Meter Image_270x270.webp",
    description:
      "The Dr. Chek D+ Glucose Dehydrogenase based blood glucose meter offers precise blood sugar testing for effective diabetes management. Utilizing advanced GDH technology, it delivers accurate readings, minimizing interference from hematocrit (Hct) levels, ensuring reliable results across diverse patient populations. This glucose meter is designed for home and professional use, providing a simple, user-friendly experience. With high precision, the Dr. Chek D+ empowers individuals to confidently monitor their blood glucose levels, aiding in proactive health decisions. Ideal for those seeking an accurate and reliable diabetes meter, the Dr. Chek D+ prioritizes precision and Hct correction for optimal blood glucose monitoring.",

    features: [
      "Amperometric Biosensor - GDH FAD",
      "Result Time of 5 Seconds",
      "Minimal Sample of 0.5 uL",
      "Enhanced HCT Range ",
      "Fasting & Post Meal Indicator",
      "Highly Accurate Measurement with Silver Electrodes",
      "Enhanced Shelf life and open vial stability",
    ],
    brochure: {
      pages: [
        "/images/Dr-Chek-D+-Glucose-Meter-brochure-page-1.jpg",
        "/images/Dr-Chek-D+-Glucose-Meter-brochure-page-2.jpg",
      ],
      url: "/Dr.Chek-D+Glucose-Meter-brochure.pdf",
    },
  };

  return (
    <div>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta
          name="keywords"
          content="Blood glucose meter, Glucose meter, Blood sugar meter, Diabetes meter, Blood glucose monitoring, Blood sugar testing, Home glucose testing, Glucometer, BGM, Best blood glucose meter for home use, Accurate blood sugar testing device, Diabetes glucose monitoring system, Non-invasive blood glucose meter, FDA-approved glucometer, Affordable blood sugar testing kit, Easy-to-use glucose monitor for seniors, Smart blood glucose meter with app, Portable blood glucose monitoring device, Buy blood glucose meter online, Best glucometer for diabetes patients, Dr. Chek D glucose meter reviews, Compare blood sugar meters, Cheap and accurate glucometer"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://yourwebsite.com" />
      </Helmet>
      <Header />
      <ProductsBanner
        title="Dr. Chek D+"
        backgroundImage="/images/dr-chek-banner-001.png"
        backgrond="cover"
        height="400px"
      />
      <IndividualProduct product={productData} />

      <Footer />
      <WhatsAppFloatingButton />
    </div>
  );
};
export default BloodGlucos2;
